import Modal from "../Modal";
import "./SideModal.css";

function SideModal(props) {
    return <Modal {...props}/>
}

SideModal.defaultProps = {
    modalClass : 'modal side-modal',
    autoClose : false
}

export default SideModal